import React from 'react'
import { AddPfpWl } from '../../components/addpfpwl/AddPfpWl'
import { AddToken } from '../../components/addtoken/AddToken'
import { CheckPassword } from '../../components/checkpassword/CheckPassword'
import { CreateBanner } from '../../components/createbanner/CreateBanner'
import Page from '../../components/page/Page'
import { useSharedState } from '../../components/waxplorer/Waxplorer'

import NotFound from '../404'

const AdminPage = () => {
    const [state, dispatch] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const password = state.password

    const onSubmitPW = (data) => {
        dispatch({ type: 'SET_PASSWORD', payload: data.password })
    }

    return ![
        'frcqu.wam',
        't1.5c.wam',
        'tgz5k.wam',
        'scfay.wam',
        'nonoswax.gm',
    ].includes(userName) ? (
        <NotFound />
    ) : (
        <Page id={'AdminPage'} banners={false}>
            {password ? (
                <div>
                    <div className={'relative'}>
                        <CreateBanner />
                        <AddToken accountName={userName} password={password} />
                        <AddPfpWl accountName={userName} password={password} />
                    </div>
                </div>
            ) : (
                <>
                    <CheckPassword onSubmit={onSubmitPW} />
                </>
            )}
        </Page>
    )
}

export default AdminPage
